import React from 'react'
import { CircularProgress } from '../Progress'

const Spinner = props => {
  return <CircularProgress {...props} />
}
Spinner.displayName = 'Spinner'
export default Spinner
